import React from 'react';
import { BrowserRouter, Navigate } from 'react-router-dom';
import { Route, Routes } from 'react-router-dom';
import { DataIntegrationFlow } from 'src/features/Signup/components/templates/DataIntegrationFlow';
import { DataIntegrationStepControlsProvider } from 'src/features/Signup/contexts/DataIntegrationStepControlsContext/DataIntegrationStepControlsContextProvider';
import MarketingPageHeader from 'src/features/MP/components/organisms/MarketingPageHeader';
import { ConnectChannelsStepRoute } from './steps/ConnectChannelsStepRoute';
import { DataUploadStepRoute } from './steps/DataUploadStepRoute';
import { PreparingYourDataStepRoute } from './steps/PreparingYourDataStepRoute';
import { CampaignMappingStepRoute } from './steps/CampaignMappingStepRoute';
import { StartModelingStepRoute } from './steps/StartModelingStepRoute';
import { InviteColleaguesStepRoute } from './steps/InviteColleaguesStepRoute';

export const DataIntegration: React.FC = () => {
  return (
    <BrowserRouter>
      <MarketingPageHeader showLinks={false} />
      <DataIntegrationStepControlsProvider>
        <Routes>
          <Route path="/data-integration" element={<DataIntegrationFlow />}>
            <Route
              path="connect-channels"
              element={<ConnectChannelsStepRoute />}
            />
            <Route path="data-upload" element={<DataUploadStepRoute />} />
            <Route
              path="preparing-data"
              element={<PreparingYourDataStepRoute />}
            />
            <Route
              path="campaign-match"
              element={<CampaignMappingStepRoute />}
            />
            <Route path="start-modeling" element={<StartModelingStepRoute />} />
            <Route
              path="invite-colleagues"
              element={<InviteColleaguesStepRoute />}
            />
          </Route>
          <Route
            path="*"
            element={
              <Navigate to="/data-integration/connect-channels" replace />
            }
          />
        </Routes>
      </DataIntegrationStepControlsProvider>
    </BrowserRouter>
  );
};
